module.exports = __webpack_public_path__ + "static/media/buzzwords_live.90399bc6.png";